import { Component, inject, Input } from "@angular/core";
import { parseISO } from "date-fns";
import {
  PostCalculateOrderResponse,
  SubscriptionDetail,
} from "src/app/core/services/myqq";
import { MoneyRepresentation } from "src/app/shared/utilities/types";
import { Observable } from "rxjs";
import { UnleashService } from "src/app/shared/services/unleash.service";
import { CartService } from "src/app/core/ngrx/myqq/cart/cart.service";

@Component({
  selector: "myqq-cart-totals",
  templateUrl: "./cart-totals.component.html",
  styleUrls: ["./cart-totals.component.scss"],
  standalone: false,
})
export class CartTotalsComponent {
  @Input() markDowns?: PostCalculateOrderResponse["markDowns"];
  @Input()
  readonly orderTotal?: string;
  @Input()
  readonly nextBillingAmount?: string;
  @Input()
  readonly currentSubscription?: SubscriptionDetail;
  @Input()
  readonly priceOverride?: MoneyRepresentation;
  @Input()
  readonly promoMessage?: string;
  constructor(private readonly unleashService: UnleashService) {}

  @Input()
  readonly taxTotal?: string;
  readonly showTaxInCart$: Observable<boolean> = this.unleashService
    .showTaxInCart$;
  private cartService = inject(CartService);
  public readonly cartPromoOverrides = this.cartService.cartPromoOverrides;

  readonly getNextBillingDate = (renewalDate?: string) =>
    (renewalDate ? parseISO(renewalDate) : new Date()).getDate();

  shouldShowCartPromoOverride(): boolean {
    return (
      this.cartPromoOverrides().cartTextBelowMonthlyPrice &&
      !!this.markDowns?.length
    );
  }
}
